import { IoMdClose } from 'react-icons/io';
import React from 'react';
import styled from 'styled-components';
import LinePoint from './LinePoint';
import { InputDate } from '../Common';
import { getDateOrEmpty } from '../../utils/DateFormatter';
import colors from './../../res/styles/Colors';

const DateCompact = ({
    className,
    date,
    content,
    hasLine = true,
    color = 'black',
    isEditable = false,
    id,
    onChange,
    onDelete
}) => {
    const formattedDate = getDateOrEmpty(date, 'DD/MMM/YYYY');

    return (
        <div className={className}>
            <StyledLinePointCompact color={color} hasLine={hasLine} circlePosition='bottom' />
            {isEditable ? (
                <>
                    <StyledInputDate
                        id={id}
                        color={color}
                        dateAsLong={date}
                        onChange={(event) => {
                            onChange && onChange(id, event.target.value);
                        }}
                    />
                    {date != null && (
                        <DeleteButton onClick={() => onDelete && onDelete(id)} title='Remove date'>
                            <IoMdClose />
                        </DeleteButton>
                    )}
                </>
            ) : (
                <DateText>{formattedDate}</DateText>
            )}
            <StyledContent color={color}>{content}</StyledContent>
        </div>
    );
};

const DeleteButton = styled.button`
    background-color: ${colors.red};
    color: white;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    max-width: 32px;
    max-height: 32px;
    cursor: pointer;
    padding: 0;
    margin: 0 auto 4px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    svg {
        width: 22px;
        height: 22px;
    }

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
    }

    &:active {
        transform: scale(0.95);
    }
`;

const DateText = styled.p`
    margin-bottom: 0;
    font-size: 13px;
`;

const StyledContent = styled.p`
    color: ${({ color }) => color};
    font-weight: bold;
    margin: 0;
    font-size: 13px;
`;

const StyledLinePointCompact = styled(LinePoint)`
    margin: auto;
    width: 30px;
    height: ${({ hasLine }) => (hasLine ? '20px' : 'auto')};
`;

const StyledInputDate = styled(InputDate)`
    && {
        height: 30px;
        width: 160px;
        margin: 3px auto;
        font-size: 12px;

        :focus {
            box-shadow: none;
            border-color: ${({ color }) => color};
        }
    }
`;

export default DateCompact;
